import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GenericButton, { GenericButtonTypeEnum } from './GenericButton';

/**
 * A list that is empty because of its filters, said as such, with the way out.
 *
 * The empty-list illustration stays for a list that really has nothing: shown here it
 * would read as "there are no invoices" when the truth is "none match".
 */
const FilteredEmptyState: React.FC<{ message?: string; onClear: () => void; clearLabel?: string }> = ({ message, onClear, clearLabel }) => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" spacing={1.5}>
      <Typography sx={{ fontSize: 14 }}>{message ?? t('filters.nothingMatches')}</Typography>
      <GenericButton buttonType={GenericButtonTypeEnum.Secondary} variant="outlined" label={clearLabel ?? t('filters.clearAll')} onClick={onClear} />
    </Stack>
  );
};

export default FilteredEmptyState;
